import { FileText, X } from 'lucide-react'
import { formatBytes } from '@/lib/format'
import { cn } from '@/lib/utils'

/**
 * Chip for a locally attached file (name + size + remove) — the wizard's PO
 * document before it uploads. Presentational; the drop zone owns the state.
 */
export function FileChip({
  file,
  onRemove,
  className,
}: {
  file: File
  onRemove?: () => void
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-md border border-rule/80 bg-card px-3 py-2 text-sm text-inkSoft',
        className,
      )}
    >
      <FileText aria-hidden="true" className="size-4 shrink-0 text-mute" />
      <span className="max-w-56 truncate font-medium">{file.name}</span>
      <span className="font-mono text-xs text-mute">{formatBytes(file.size)}</span>
      {onRemove ? (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remove ${file.name}`}
          className="rounded-sm p-0.5 text-mute transition-colors duration-[180ms] ease-editorial hover:text-rust"
        >
          <X className="size-3.5" />
        </button>
      ) : null}
    </span>
  )
}
